import Registration from '../../modules/Auth/components/Registration';

function PageRegister() {
    return <><Registration/></>
}

export default PageRegister;
